export const getForbiddenResponseMessage = (error) => {
    const response = error?.response;

    if (response?.status !== 403) {
        return "";
    }

    return response?.data?.message || response?.data?.errorMessage || response?.data?.Message || "";
};
